const graph = {
  nodes: [
    { id: "a", status: "INFECTED" },
    { id: "b" },
    { id: "c" },
    { id: "a2" },
    { id: "a3" },
    { id: "b2" },
    { id: "c2", age: "elder" },
    { id: "c3" },

    { id: "d1" },
    { id: "d2", age: "elder", immuno: true },
    { id: "d3", age: "elder" },
    { id: "d4" },
    { id: "d5" },
    { id: "d6" },
    { id: "d7", age: "elder" },
    { id: "d8" },
    { id: "d9", age: "elder" },
    { id: "d10" },
    { id: "d11" },
    { id: "d12", age: "child" },

    { id: "e1" },
    { id: "e2", age: "elder" },
    { id: "e3" },
    { id: "e4" },
    { id: "e5" },
    { id: "e6" },
    { id: "e7" },
    { id: "e8", age: "elder", immuno: true },

    { id: "f", age: "elder", immuno: true },

    { id: "g", age: "child", immuno: true }
  ],
  links: [
    { source: "a", target: "b", priority: "CONTACT" },
    { source: "a", target: "c", priority: "CONTACT" },
    { source: "b", target: "c", priority: "CONTACT" },

    { source: "a", target: "a2", priority: "CONTACT" },
    { source: "a", target: "a3", priority: "CONTACT" },

    { source: "b", target: "b2", priority: "CONTACT" },

    { source: "c", target: "c2", priority: "CONTACT" },
    { source: "c", target: "c3", priority: "CONTACT" },

    { source: "a2", target: "d1", priority: "CONTACT" },
    { source: "a2", target: "d2", priority: "CONTACT" },
    { source: "a2", target: "d3", priority: "CONTACT" },
    { source: "a2", target: "d4", priority: "CONTACT" },
    { source: "a2", target: "d5", priority: "CONTACT" },
    { source: "a2", target: "d6", priority: "CONTACT" },
    { source: "a2", target: "d7", priority: "CONTACT" },
    { source: "a2", target: "d8", priority: "CONTACT" },
    { source: "a2", target: "d9", priority: "CONTACT" },
    { source: "a2", target: "d10", priority: "CONTACT" },
    { source: "a2", target: "d11", priority: "CONTACT" },
    { source: "a2", target: "d12", priority: "CONTACT" },

    { source: "b2", target: "e1", priority: "CONTACT" },
    { source: "b2", target: "e2", priority: "CONTACT" },
    { source: "b2", target: "e3", priority: "CONTACT" },
    { source: "b2", target: "e4", priority: "CONTACT" },
    { source: "b2", target: "e5", priority: "CONTACT" },
    { source: "b2", target: "e6", priority: "CONTACT" },
    { source: "b2", target: "e7", priority: "CONTACT" },
    { source: "b2", target: "e8", priority: "CONTACT" },

    { source: "c2", target: "f", priority: "CONTACT" },

    { source: "e3", target: "g", priority: "CONTACT" }
  ]
};

export default graph;
